import LocomotiveScroll from 'locomotive-scroll';

let locoSetTimeout

// export function locoinit() {

const scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    multiplier: 0.84
});
scroll.on("scroll", (args) => {
    if (location.pathname == "/") {
        window.globalScrollY = args.scroll.y
        if (window.onscroll != null)
            window.onscroll()
    }
})

if (location.pathname == "/contact/") {
    let mwform
    setTimeout(() => {
        mwform = document.querySelector(".form__innerForm")
        if (mwform != null) {
            if (mwform.querySelectorAll(".error").length > 0) {
                scroll2mwform()
            } else if (mwform.classList.contains("mw_wp_form_send_error") || mwform.classList.contains("mw_wp_form_complete")) {
                scroll2mwform()
            }
        }
    }, 100)

    function scroll2mwform() {
        let scrollOffset = -window.innerWidth * 0.1
        scroll.update()
        scroll.scrollTo(mwform, {
            disableLerp: true,
            offset: scrollOffset,
        })
    }
}

if (!scroll.scroll.isMoblile && !scroll.scroll.isTablet) {
    document.querySelectorAll(".totop").forEach((btn) => {
        btn.addEventListener("click", () => {
            window.globalLocoUpdate(true, 1000)
        })
    })
}

window.globalLocoStart = () => {
    scroll.start()
}

window.globalLocoStop = () => {
    scroll.stop()
}

window.globalLocoUpdate = (boo, dura = 1) => {
    if (location.pathname == "/" || boo) {
        scroll.scrollTo("top", {
            disableLerp: true,
            duration: dura,
            callback: () => {
                scroll.update()
            }
        })
        if (location.pathname == "/")
            window.onscroll()
    } else {
        scroll.update()
    }
}

window.globalLocoScrollTo = (elm, dura = 1000) => {
    scroll.scrollTo(elm, {
        disableLerp: true,
        duration: dura
    })
}

window.addEventListener("resize", sendImgMover)

function sendImgMover() {

    if (window.innerWidth > 1024) {
        clearTimeout(locoSetTimeout)
        locoSetTimeout = setTimeout(() => {
            scroll.scrollTo("top", {
                disableLerp: true,
                callback: () => {
                    scroll.update()
                }
            })
            if (location.pathname == "/") {
                window.globalScrollY = 0
                window.onscroll()
            }
        }, 300)
    }
}

// }